import {useEffect, useRef, useState} from "react";
import SockJS from "sockjs-client";
import {Client} from "@stomp/stompjs";
import {TOKEN} from "../context/SignInContext";
import {refreshConnectHeaders} from "../utils/authTokens";

// STOMP/SockJS client for the new Knowledge Manager backend's DocumentStatusBroadcaster
// (REACT_APP_KB_MANAGER_WS_URL) - same pattern as useStompWebsocketRag.js, kept separate since it
// talks to a different backend/env var.
export const useStompWebsocketKbManager = (topic) => {
    const stompClientRef = useRef(null);
    const [updatedValue, setUpdatedValue] = useState(null);
    const [status, setStatus] = useState(null);

    useEffect(() => {
        let stompClient = null;

        const setupWebSocket = async () => {
            const wsBaseUrl = process.env.REACT_APP_KB_MANAGER_WS_URL;
            const socket = new SockJS(wsBaseUrl);

            const token = localStorage.getItem(TOKEN);
            stompClient = new Client({
                webSocketFactory: () => socket,
                connectHeaders: token ? {Authorization: `Bearer ${token}`} : {},
                beforeConnect: refreshConnectHeaders,
                reconnectDelay: 5000,
                heartbeatIncoming: 4000,
                heartbeatOutgoing: 4000,
            });

            stompClient.onConnect = () => {
                setStatus("CONNECTED");
                stompClient?.subscribe(topic, (message) => {
                    try {
                        const update = JSON.parse(message.body);
                        if (!update) return;
                        setUpdatedValue(update);
                    } catch (error) {
                        console.error("Error processing Knowledge Manager WebSocket message:", error);
                    }
                });
            };

            stompClient.onStompError = (frame) => {
                console.error("Knowledge Manager STOMP error:", frame);
                setStatus("ERROR");
            };

            stompClient.activate();
            stompClientRef.current = stompClient;
        };

        if (topic) {
            setupWebSocket();
        }

        return () => {
            if (stompClientRef?.current) {
                stompClientRef.current.deactivate();
            }
        };
    }, [topic]);

    return [updatedValue, status];
};
